import type { CardTypeT } from 'blocks/Cards/Card.h'

import { EVENT_CARD_ASPECT_RATIO } from 'blocks/Cards'
import { CARDS_ASPECT_RATIO, CardType } from 'blocks/Cards/Card.h'

export const getRowCardAspectRatioVar = (type: CardTypeT) => {
  const config = {
    [CardType.VERTICAL_EVENT_TOP_CONTENT]:
      EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_VERTICAL,
    [CardType.HORIZONTAL_EVENT_TOP_CONTENT]:
      EVENT_CARD_ASPECT_RATIO.TOP_CONTENT_HORIZONTAL,
  }

  return config[type]
}

export const getRowCardAspectRatio = (type: CardTypeT) => {
  const config = {
    [CardType.HORIZONTAL]: CARDS_ASPECT_RATIO.HORIZONTAL_DEFAULT,
    [CardType.VERTICAL]: CARDS_ASPECT_RATIO.VERTICAL_DEFAULT,
    [CardType.HORIZONTAL_VOD_TOP_CONTENT]:
      CARDS_ASPECT_RATIO.HORIZONTAL_VOD_TOP_CONTENT,
    [CardType.VERTICAL_VOD_TOP_CONTENT]:
      CARDS_ASPECT_RATIO.VERTICAL_VOD_TOP_CONTENT,
    [CardType.HORIZONTAL_CHANNEL_TOP_CONTENT]:
      CARDS_ASPECT_RATIO.HORIZONTAL_CHANNEL_TOP_CONTENT,
  }

  return config[type]
}
